/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ActivateMemberForm } from '../models/ActivateMemberForm';
import type { InviteMemberForm } from '../models/InviteMemberForm';
import type { TeamMemberDto } from '../models/TeamMemberDto';
import type { UpdateCompensationRequest } from '../models/UpdateCompensationRequest';
import type { UpdateMemberRequest } from '../models/UpdateMemberRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TeamApiService {
    /**
     * Find a team member by ID
     * Retrieve details of a team member by their ID. Ensures the request is made by the owner or someone from the same team.
     * @returns TeamMemberDto Team member found
     * @throws ApiError
     */
    public static findMember({
        id,
    }: {
        /**
         * The ID of the team member to find
         */
        id: number,
    }): CancelablePromise<TeamMemberDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/team/member/{id}',
            path: {
                'id': id,
            },
            errors: {
                403: `The request is not authorized because it is not from the owner`,
                404: `The team member was not found or is not in the same team`,
            },
        });
    }
    /**
     * Update a member
     * @returns TeamMemberDto Edited Member
     * @throws ApiError
     */
    public static updateMember({
        id,
        requestBody,
    }: {
        /**
         * Id of the member
         */
        id: number,
        /**
         * Fields to be updated
         */
        requestBody: UpdateMemberRequest,
    }): CancelablePromise<TeamMemberDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/dashboard/api/v1/team/member/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid request body`,
                403: `Request is not from an owner`,
                404: `Member not found or not in the same team`,
            },
        });
    }
    /**
     * Delete a team member
     * Removes a member from the team by their ID.
     * @returns any Member deleted successfully
     * @throws ApiError
     */
    public static deleteMember({
        id,
    }: {
        /**
         * ID of the team member to delete
         */
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/dashboard/api/v1/team/member/{id}',
            path: {
                'id': id,
            },
            errors: {
                403: `Unauthorized request`,
                404: `Team member not found`,
            },
        });
    }
    /**
     * Update a team member compensation
     * @returns TeamMemberDto Edited Member
     * @throws ApiError
     */
    public static updateCompensation({
        id,
        requestBody,
    }: {
        id: number,
        /**
         * Compensation
         */
        requestBody: UpdateCompensationRequest,
    }): CancelablePromise<TeamMemberDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/dashboard/api/v1/team/member/{id}/compensation',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid request body`,
                403: `Request is not from an owner`,
                404: `Member not found or not in the same team`,
            },
        });
    }
    /**
     * @returns TeamMemberDto OK
     * @throws ApiError
     */
    public static dashboardActivateMember({
        token,
        requestBody,
    }: {
        token: string,
        requestBody: ActivateMemberForm,
    }): CancelablePromise<TeamMemberDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/dashboard/api/v1/activate-account',
            query: {
                'token': token,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Activate a member account
     * Activates an invited team member's account after redirection from the invitation email.
     * @returns TeamMemberDto Account activated successfully
     * @throws ApiError
     */
    public static activateMember({
        token,
        requestBody,
    }: {
        /**
         * Activation token
         */
        token: string,
        requestBody: ActivateMemberForm,
    }): CancelablePromise<TeamMemberDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/team/member',
            query: {
                'token': token,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid request body`,
                403: `Invalid token`,
                409: `Conflict: Team member already exists`,
                410: `Member already activated`,
            },
        });
    }
    /**
     * Invites a new member in a team
     * An invitation email will be sent upon successful creation.
     * @returns TeamMemberDto Created Member
     * @throws ApiError
     */
    public static inviteMember({
        requestBody,
    }: {
        /**
         * Member to be created
         */
        requestBody: InviteMemberForm,
    }): CancelablePromise<TeamMemberDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/team/member',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid request body`,
                409: `User already exists by this email`,
            },
        });
    }
    /**
     * Bulk invite multiple members in a team
     * Creates multiple team members and sends invitation emails.
     * @returns TeamMemberDto Created members
     * @throws ApiError
     */
    public static bulkInviteMembers({
        requestBody,
    }: {
        /**
         * List of members to invite
         */
        requestBody: Array<InviteMemberForm>,
    }): CancelablePromise<Array<TeamMemberDto>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/team/member/bulk',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid request body`,
                409: `Conflict: User already exists`,
            },
        });
    }
    /**
     * Send a manual invite to a team member
     * Allows the owner to manually send an invitation to an existing or potential team member by their ID.
     * @returns any Invitation sent successfully
     * @throws ApiError
     */
    public static manualInvite({
        teamMemberId,
    }: {
        /**
         * The ID of the team member to invite
         */
        teamMemberId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/team/manual-invite/{teamMemberId}',
            path: {
                'teamMemberId': teamMemberId,
            },
            errors: {
                403: `Request is not authorized`,
                404: `Team member not found`,
            },
        });
    }
    /**
     * List members in a team
     * Fetches all members in the team associated with the authenticated user.
     * @returns TeamMemberDto List of all members in the team
     * @throws ApiError
     */
    public static listMembers(): CancelablePromise<Array<TeamMemberDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/team',
        });
    }
    /**
     * List members in a team for sales reassignment
     * Fetches all members in the team associated with the authenticated user.
     * @returns TeamMemberDto List of all members in the team for sales reassignment
     * @throws ApiError
     */
    public static listMembersForSalesReassignment({
        creatorId,
    }: {
        creatorId: number,
    }): CancelablePromise<Array<TeamMemberDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/team/sales-reassignment/{creatorId}',
            path: {
                'creatorId': creatorId,
            },
        });
    }
}
